import React from 'react';
import RepVisitsUnlockPremiumView from '../RepVisitsUnlockPremiumView';
import agendaUnlockMessages from './agenda-unlock-messages';

const unlockPremiumProps = {
  activeStyle: 'agendaview',
  hideTopHeader: true,
  messages: agendaUnlockMessages,
};

const RepVisitsAgendaUnlockPage = () => <RepVisitsUnlockPremiumView {...unlockPremiumProps} />;
RepVisitsAgendaUnlockPage.title = () => 'Agenda';

export default RepVisitsAgendaUnlockPage;
